<template>
    <div v-if="debugEnabled" :class="css">
        <div class="hero-homepage__debug-button" v-for="(item, key) in buttons" :key="key" @click="click(item)">
            {{ item.label }}
        </div>
        <div v-if="debug" class="hero-homepage__debug-content" v-html="content"/>
    </div>
</template>

<script>
export default {
    name: "heroHomepageDebug",
    props: {
        buttons: Array,
        background: Boolean,
        debug: Boolean,
        debugEnabled: Boolean,
        items: Array,
    },
    emits: ['click'],
    computed: {
        css() {
            return [
                'hero-homepage__debug',
                this.background && 'hero-homepage__debug--background'
            ];
        },
        content() {
            if (!this.debugEnabled) {
                return [];
            }

            return (this.items || []).map((item) => {
                if (typeof item === 'string') {
                    return `<span>${item}</span>`;
                } else if (typeof item === 'object') {
                    if (item.key) {
                        return `<span>${item.key}: ${item.value}</span>`;
                    } else {
                        const subItems = [];
                        for (let key in item) {
                            if (item.hasOwnProperty(key)) {
                                subItems.push(`<span>${key}: ${item[key]}</span>`);
                            }
                        }
                        return subItems.join('');
                    }
                }
                return '';
            }).join('');
        },
    },
    methods: {
        click(item) {
            item && typeof item.click === 'function' && item.click();
        }
    }
}
</script>
